import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import theme from '../theme'
import {Scroll} from "vuetify/lib/directives";

Vue.use(Vuetify, {
  directives:{
    Scroll
  },
  theme
})
